import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FileTextIcon, CheckIcon, InfoIcon, EyeIcon, DownloadIcon, ArrowRightIcon, CheckCircleIcon, CalendarIcon, MapPinIcon, StarIcon } from 'lucide-react';
import Card from '../../components/Card';
import Button from '../../components/Button';
const MicroSukukListing = () => {
  const navigate = useNavigate();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [listingDate, setListingDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const handleListing = (e: React.FormEvent) => {
    e.preventDefault();
    setShowConfirmation(true);
  };
  if (showConfirmation) {
    return <div className="min-h-screen bg-neutral-50 flex flex-col justify-center items-center p-4" data-id="element-1010">
        <div className="w-full max-w-md" data-id="element-1011">
          <Card data-id="element-1012">
            <div className="text-center mb-6" data-id="element-1013">
              <div className="flex justify-center mb-4" data-id="element-1014">
                <div className="w-16 h-16 rounded-full bg-success bg-opacity-10 flex items-center justify-center" data-id="element-1015">
                  <CheckCircleIcon className="w-8 h-8 text-success" data-id="element-1016" />
                </div>
              </div>
              <h2 className="text-xl font-bold text-success" data-id="element-1017">
                Micro-Sukuk Listed Successfully!
              </h2>
              <p className="text-neutral-500 mt-2" data-id="element-1018">
                The micro-sukuk has been listed on the marketplace and is now
                available for investor subscription.
              </p>
            </div>
            <div className="bg-neutral-50 p-4 rounded-lg mb-6" data-id="element-1019">
              <h3 className="font-medium mb-2" data-id="element-1020">Listing Details</h3>
              <div className="space-y-2 text-sm" data-id="element-1021">
                <div className="flex justify-between" data-id="element-1022">
                  <span className="text-neutral-400" data-id="element-1023">Sukuk ID</span>
                  <span className="font-medium" data-id="element-1024">MS2023-102</span>
                </div>
                <div className="flex justify-between" data-id="element-1025">
                  <span className="text-neutral-400" data-id="element-1026">Business</span>
                  <span className="font-medium" data-id="element-1027">Halal Delights</span>
                </div>
                <div className="flex justify-between" data-id="element-1028">
                  <span className="text-neutral-400" data-id="element-1029">Amount</span>
                  <span className="font-medium" data-id="element-1030">RM 35,000</span>
                </div>
                <div className="flex justify-between" data-id="element-1031">
                  <span className="text-neutral-400" data-id="element-1032">Listing Period</span>
                  <span className="font-medium" data-id="element-1033">14 days</span>
                </div>
              </div>
            </div>
            <div className="bg-primary bg-opacity-5 border border-primary border-opacity-20 rounded-lg p-4 mb-6" data-id="element-1034">
              <div className="flex items-center" data-id="element-1035">
                <InfoIcon className="w-5 h-5 text-primary mr-2 flex-shrink-0" data-id="element-1036" />
                <p className="text-sm" data-id="element-1037">
                  You can monitor the funding progress and investor
                  subscriptions from your dashboard.
                </p>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row justify-center gap-3" data-id="element-1038">
              <Link to="/digital-advisor-portal" data-id="element-1039">
                <Button variant="outline" data-id="element-1040">Return to Dashboard</Button>
              </Link>
              <Link to="/demo/investor-view" data-id="element-1041">
                <Button variant="primary" icon={<EyeIcon className="w-4 h-4" data-id="element-1043" />} iconPosition="left" data-id="element-1042">
                  View Listed Micro-Sukuk
                </Button>
              </Link>
            </div>
          </Card>
        </div>
      </div>;
  }
  return <div className="max-w-4xl mx-auto" data-id="element-1044">
      <div className="mb-6" data-id="element-1045">
        <h1 className="text-2xl font-bold text-secondary mb-2" data-id="element-1046">
          List Micro-Sukuk on Marketplace
        </h1>
        <p className="text-neutral-400" data-id="element-1047">
          Review and configure marketplace listing details
        </p>
      </div>
      <form onSubmit={handleListing} data-id="element-1048">
        {/* Micro-Sukuk Overview */}
        <section className="mb-8" data-id="element-1049">
          <Card data-id="element-1050">
            <div className="flex items-center mb-6" data-id="element-1051">
              <div className="w-12 h-12 rounded-full bg-success bg-opacity-10 flex items-center justify-center mr-4" data-id="element-1052">
                <FileTextIcon className="w-6 h-6 text-success" data-id="element-1053" />
              </div>
              <div data-id="element-1054">
                <h3 className="font-bold text-lg" data-id="element-1055">
                  MS2023-102 • Halal Delights
                </h3>
                <div className="flex items-center text-sm text-neutral-400" data-id="element-1056">
                  <span data-id="element-1057">Equipment Purchase</span>
                  <span className="mx-2" data-id="element-1058">•</span>
                  <span data-id="element-1059">RM 35,000</span>
                  <span className="mx-2" data-id="element-1060">•</span>
                  <span data-id="element-1061">Ready to List</span>
                </div>
              </div>
              <div className="ml-auto bg-success bg-opacity-10 text-success px-3 py-1 rounded-full text-sm font-medium" data-id="element-1062">
                All Steps Completed
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1063">
              <div data-id="element-1064">
                <h4 className="font-medium mb-3" data-id="element-1065">Application Overview</h4>
                <div className="space-y-3" data-id="element-1066">
                  <div className="flex justify-between" data-id="element-1067">
                    <span className="text-sm text-neutral-400" data-id="element-1068">Purpose</span>
                    <span className="text-sm font-medium" data-id="element-1069">
                      Equipment Purchase
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-1070">
                    <span className="text-sm text-neutral-400" data-id="element-1071">Amount</span>
                    <span className="text-sm font-medium" data-id="element-1072">RM 35,000</span>
                  </div>
                  <div className="flex justify-between" data-id="element-1073">
                    <span className="text-sm text-neutral-400" data-id="element-1074">Duration</span>
                    <span className="text-sm font-medium" data-id="element-1075">6 months</span>
                  </div>
                  <div className="flex justify-between" data-id="element-1076">
                    <span className="text-sm text-neutral-400" data-id="element-1077">
                      Profit Rate
                    </span>
                    <span className="text-sm font-medium" data-id="element-1078">18% p.a.</span>
                  </div>
                </div>
              </div>
              <div data-id="element-1079">
                <h4 className="font-medium mb-3" data-id="element-1080">Review Status</h4>
                <div className="space-y-3" data-id="element-1081">
                  <div className="flex items-center justify-between" data-id="element-1082">
                    <div className="flex items-center" data-id="element-1083">
                      <CheckCircleIcon className="w-5 h-5 text-success mr-2" data-id="element-1084" />
                      <span className="text-sm" data-id="element-1085">Digital Advisor Review</span>
                    </div>
                    <span className="text-sm text-success" data-id="element-1086">Approved</span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-1087">
                    <div className="flex items-center" data-id="element-1088">
                      <CheckCircleIcon className="w-5 h-5 text-success mr-2" data-id="element-1089" />
                      <span className="text-sm" data-id="element-1090">Rating Assessment</span>
                    </div>
                    <span className="text-sm text-success" data-id="element-1091">Low Risk (A)</span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-1092">
                    <div className="flex items-center" data-id="element-1093">
                      <CheckCircleIcon className="w-5 h-5 text-success mr-2" data-id="element-1094" />
                      <span className="text-sm" data-id="element-1095">Shariah Review</span>
                    </div>
                    <span className="text-sm text-success" data-id="element-1096">Approved</span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-1097">
                    <div className="flex items-center" data-id="element-1098">
                      <CheckCircleIcon className="w-5 h-5 text-success mr-2" data-id="element-1099" />
                      <span className="text-sm" data-id="element-1100">Contract Signing</span>
                    </div>
                    <span className="text-sm text-success" data-id="element-1101">Completed</span>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </section>
        {/* Listing Configuration */}
        <section className="mb-8" data-id="element-1102">
          <Card data-id="element-1103">
            <h3 className="font-bold text-lg mb-6" data-id="element-1104">Listing Configuration</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-1105">
              <div data-id="element-1106">
                <label className="block text-sm font-medium mb-2" data-id="element-1107">
                  Listing Start Date
                </label>
                <input type="date" className="w-full border border-neutral-200 rounded-lg py-2 px-3 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary" value={listingDate} onChange={e => setListingDate(e.target.value)} required data-id="element-1108" />
              </div>
              <div data-id="element-1109">
                <label className="block text-sm font-medium mb-2" data-id="element-1110">
                  Listing End Date
                </label>
                <input type="date" className="w-full border border-neutral-200 rounded-lg py-2 px-3 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary" value={endDate} onChange={e => setEndDate(e.target.value)} required data-id="element-1111" />
              </div>
            </div>
            <div className="mb-6" data-id="element-1112">
              <label className="block text-sm font-medium mb-2" data-id="element-1113">
                Investment Limits
              </label>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1114">
                <div data-id="element-1115">
                  <label className="block text-xs text-neutral-400 mb-1" data-id="element-1116">
                    Minimum Investment (RM)
                  </label>
                  <input type="number" className="w-full border border-neutral-200 rounded-lg py-2 px-3 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary" defaultValue="100" required data-id="element-1117" />
                </div>
                <div data-id="element-1118">
                  <label className="block text-xs text-neutral-400 mb-1" data-id="element-1119">
                    Maximum Investment (RM)
                  </label>
                  <input type="number" className="w-full border border-neutral-200 rounded-lg py-2 px-3 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary" defaultValue="5000" required data-id="element-1120" />
                </div>
              </div>
            </div>
            <div data-id="element-1121">
              <label className="block text-sm font-medium mb-2" data-id="element-1122">
                Business Description
              </label>
              <textarea className="w-full border border-neutral-200 rounded-lg py-2 px-3 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary" rows={3} defaultValue="Family restaurant seeking equipment financing for kitchen upgrades to improve service efficiency and expand menu offerings." required data-id="element-1123"></textarea>
            </div>
          </Card>
        </section>
        {/* Marketplace Preview */}
        <section className="mb-8" data-id="element-1124">
          <Card data-id="element-1125">
            <h3 className="font-bold text-lg mb-4" data-id="element-1126">Marketplace Preview</h3>
            <div className="border border-neutral-200 rounded-lg p-6" data-id="element-1127">
              <div className="flex flex-col md:flex-row gap-6" data-id="element-1128">
                <div className="md:w-1/3" data-id="element-1129">
                  <div className="h-48 bg-cover bg-center rounded-lg mb-4" style={{
                  backgroundImage: "url('https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80')"
                }} data-id="element-1130"></div>
                  <h3 className="font-bold text-lg mb-2" data-id="element-1131">Halal Delights</h3>
                  <div className="flex items-center text-sm text-neutral-400 mb-3" data-id="element-1132">
                    <MapPinIcon className="w-4 h-4 mr-1" data-id="element-1133" />
                    <span data-id="element-1134">Kuala Lumpur</span>
                  </div>
                  <div className="flex items-center mb-4" data-id="element-1135">
                    <div className="flex" data-id="element-1136">
                      {[1, 2, 3, 4].map(star => <StarIcon key={star} className="w-4 h-4 text-accent" fill="currentColor" data-id="element-1137" />)}
                      <StarIcon className="w-4 h-4 text-neutral-200" data-id="element-1138" />
                    </div>
                    <span className="text-xs text-neutral-400 ml-2" data-id="element-1139">
                      4.0 (15 reviews)
                    </span>
                  </div>
                </div>
                <div className="md:w-2/3" data-id="element-1140">
                  <div className="flex justify-between items-start mb-4" data-id="element-1141">
                    <div data-id="element-1142">
                      <h2 className="text-xl font-bold" data-id="element-1143">
                        Equipment Financing Micro-Sukuk
                      </h2>
                      <p className="text-neutral-400" data-id="element-1144">Sukuk ID: MS2023-102</p>
                    </div>
                    <div className="bg-primary bg-opacity-10 text-primary px-3 py-1 rounded-full text-sm font-medium" data-id="element-1145">
                      Coming Soon
                    </div>
                  </div>
                  <p className="text-sm mb-6" data-id="element-1146">
                    Family restaurant seeking equipment financing for kitchen
                    upgrades to improve service efficiency and expand menu
                    offerings.
                  </p>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6" data-id="element-1147">
                    <div className="bg-neutral-50 p-3 rounded-lg" data-id="element-1148">
                      <div className="text-xs text-neutral-400" data-id="element-1149">Amount</div>
                      <div className="font-medium" data-id="element-1150">RM 35,000</div>
                    </div>
                    <div className="bg-neutral-50 p-3 rounded-lg" data-id="element-1151">
                      <div className="text-xs text-neutral-400" data-id="element-1152">Term</div>
                      <div className="font-medium" data-id="element-1153">6 months</div>
                    </div>
                    <div className="bg-neutral-50 p-3 rounded-lg" data-id="element-1154">
                      <div className="text-xs text-neutral-400" data-id="element-1155">
                        Profit Rate
                      </div>
                      <div className="font-medium" data-id="element-1156">18% p.a.</div>
                    </div>
                    <div className="bg-neutral-50 p-3 rounded-lg" data-id="element-1157">
                      <div className="text-xs text-neutral-400" data-id="element-1158">
                        Min. Investment
                      </div>
                      <div className="font-medium" data-id="element-1159">RM 100</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </section>
        {/* Submit Section */}
        <section className="mb-8" data-id="element-1160">
          <Card data-id="element-1161">
            <div className="flex items-center mb-6" data-id="element-1162">
              <div className="w-10 h-10 rounded-full bg-primary bg-opacity-10 flex items-center justify-center mr-3" data-id="element-1163">
                <InfoIcon className="w-5 h-5 text-primary" data-id="element-1164" />
              </div>
              <div data-id="element-1165">
                <h3 className="font-medium" data-id="element-1166">Ready to List</h3>
                <p className="text-sm text-neutral-400" data-id="element-1167">
                  Please review all details before listing on the marketplace
                </p>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row justify-end gap-3" data-id="element-1168">
              <Button variant="outline" type="button" data-id="element-1169">
                Save Draft
              </Button>
              <Button variant="primary" type="submit" icon={<ArrowRightIcon className="w-4 h-4" data-id="element-1171" />} iconPosition="right" data-id="element-1170">
                List on Marketplace
              </Button>
            </div>
          </Card>
        </section>
      </form>
    </div>;
};
export default MicroSukukListing;